import { useState, useEffect, useMemo } from 'react';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useUsersFromCollaborationGraph } from '../get-collaborators/index.tsx';
import type { Collaborators } from '../get-collaborators/types.tsx';
import { getConfluenceUsers } from '../permission-check-bulk/index.tsx';

export const useCollaborators = (isEnrolled: boolean) => {
	const [collaborators, setCollaborators] = useState<Collaborators>([]);
	const [isLoading, setIsLoading] = useState(true);

	const cloudId = useCloudId();
	const getCollaborators = useUsersFromCollaborationGraph(cloudId);

	useEffect(() => {
		const fetch = async () => {
			try {
				const users = await getCollaborators();
				if (!!users && users.length !== 0) {
					const confluenceUsers = await getConfluenceUsers(users, cloudId);
					setCollaborators(confluenceUsers);
				}
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				fireErrorAnalytics({
					meta: {
						id: 'useCollaborators',
						packageName: 'jiraCrossJoinNudges',
					},
					error,
					sendToPrivacyUnsafeSplunk: true,
				});
			} finally {
				setIsLoading(false);
			}
		};
		if (isEnrolled) {
			fetch();
		}
	}, [cloudId, getCollaborators, isEnrolled]);

	return useMemo(() => ({ collaborators, isLoading }), [collaborators, isLoading]);
};
